module.exports = __webpack_public_path__ + "img/Logo.e92b289e.png";